"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
function cancelDisconnectSource(sourceId) {
  return (0, _actionUtils.actionCreator)(_types.BROADCAST_CANCEL_SOURCE_DISCONNECT, {
    sourceId: sourceId
  });
}
var _default = exports["default"] = cancelDisconnectSource;